import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/Auth/auth.service';

@Component({
  selector: 'app-redirect',
  imports: [],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.scss'
})
export class RedirectComponent {
  // injectables
  route = inject(ActivatedRoute)
  router = inject(Router)
  auth_service = inject(AuthService)

  constructor() {
    const params = this.route.snapshot.queryParams

    // basic authetication checking
    // let the page check for access control
    switch (params['type']) {
      case 'product':
        if (!this.auth_service.isAuthenticated()) return
        this.router.navigate([this.auth_service.getRoleIndex(), 'products', params['uuid']])
        break;
      case 'concern':
        if (!this.auth_service.isAuthenticated()) return
        this.router.navigate([this.auth_service.getRoleIndex(), 'concerns'], {
          queryParams: params
        })
        break;
      default: // default to role index
        this.router.navigate([this.auth_service.getRoleIndex()])
        break;
    }
  }
}
